import { TSocialLinkField } from './socialLinksFormSchema'

// Older QR codes store built-in platform logos with provider 'r2', which the API rejects for a logo without a publicId.
export const normalizeSocialLinkLogo = (
	logo: TSocialLinkField['logo'],
): TSocialLinkField['logo'] => {
	if (!logo || typeof logo.src !== 'string' || logo.publicId) {
		return logo
	}
	return { src: logo.src, provider: 'none' }
}
